import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/style.scss';
// import "./Index.scss"

// import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import RouterIndex from './RouterIndex';
import "./css/_theme-vars.scss"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
   {/* <PageTransition /> */}
    <RouterIndex />
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
